// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventKindCoverageFreq } from './eventKindCoverageFreq';
import type { EventKindCoverageMinAvailableSlotsRolling } from './eventKindCoverageMinAvailableSlotsRolling';

/**
 * Flexible cadence & coverage requirements for planner.
 */
export interface EventKindCoverage {
  /**
   * Planning horizon / look-ahead window for planning
   * @minimum 1
   * @maximum 24
   */
  horizonMo: number;
  freq: EventKindCoverageFreq;
  /**
   * Every N weeks/months
   * @minimum 1
   */
  interval: number;
  /** Minimum available (bookable) slots within the rolling horizon window */
  minAvailableSlotsRolling?: EventKindCoverageMinAvailableSlotsRolling;
}
